<template>
  <v-row align-content="center" class="text-little">
    <v-col cols="7" class="text-truncate">
      <div class="tondino" :style="{ backgroundColor: color }"></div>
      {{ label }}
    </v-col>
    <v-col cols="5" class="text-right pr-5">
      <span v-if="viewData">
        {{ value | currencyFormat }}
      </span>
      <span v-else> **** </span></v-col
    >
  </v-row>
</template>

<script>
export default {
  name: "legend-row",
  props: { label: String, value: Number, color: String, viewData: Boolean },
};
</script>

<style scoped>
.tondino {
  width: 10px;
  height: 10px;
  border-style: solid;
  border-width: 1px;
  display: inline-block;
  margin: 0 10px;
}
</style>
